const PARAM = 'continue'

/**
 * Where to return when a screen has nowhere to go back to.
 *
 * `?continue=` is the parameter these screens already read to return after submitting; it matters
 * on a COLD entry, which is every entry coming from the migrated professional area — it arrives
 * with a full navigation, so this app's history starts right there and `goBack()` would fall back
 * to `/` (the projects list).
 *
 * Only in-app paths are honoured (never an absolute URL, never protocol-relative).
 */
export const getContinuePath = () => {
	const value = new URLSearchParams(window.location.search).get(PARAM)
	return value && value.startsWith('/') && !value.startsWith('//') ? value : null
}
